<template>
	<div class="statistics-filter-panel">
		<div class="statistics-filter">
			<label class="label">{{ $t('statistics.location_in_customer_structure') }}</label>
			<StatisticsStructureSelect
				ref="structureSelect"
				:selected-customer="selectedCustomer"
				:open="structureDropdownOpen"
				:search="structureSearch"
				:loading="loadingTree"
				:options="structureOptions"
				:is-expanded="isStructureExpanded"
				@toggle="$emit('toggle-structure-dropdown')"
				@update:search="$emit('update:structureSearch', $event)"
				@option-click="$emit('structure-option-click', $event)"
				@select="$emit('select-customer', $event)"
				@toggle-node="$emit('toggle-structure-node', $event)"
			/>
		</div>

		<div class="statistics-filter date-filter">
			<label class="label">{{ $t('statistics.from') }}</label>
			<input class="input" type="date" :value="start" @input="$emit('update:start', $event.target.value)" />
		</div>

		<div class="statistics-filter date-filter">
			<label class="label">{{ $t('statistics.to') }}</label>
			<input class="input" type="date" :value="stop" @input="$emit('update:stop', $event.target.value)" />
		</div>

		<div class="statistics-filter building-filter">
			<label class="label">{{ $t('statistics.building') }}</label>
			<select
				class="input"
				:value="buildingFilterId"
				:disabled="loadingBuildings || !selectedCustomer"
				@input="$emit('update:buildingFilterId', $event.target.value)"
			>
				<option value="">{{ $t('statistics.all_buildings') }}</option>
				<option
					v-for="building in buildingOptions"
					:key="building.id"
					:value="building.id"
				>
					{{ building.name }}
				</option>
			</select>
		</div>

		<button
			class="button is-primary statistics-search-button"
			:disabled="loading || !selectedCustomer"
			@click="$emit('search')"
		>
			{{ $t('statistics.show_statistics') }}
		</button>

		<button
			v-if="showCompareButton"
			type="button"
			class="button is-primary statistics-compare-button"
			@click="$emit('toggle-compare')"
		>
			<i class="fas fa-exchange-alt"></i>
			<span>{{ compareMode ? $t('statistics.close_comparison') : $t('statistics.compare') }}</span>
		</button>

		<button
			v-if="showPrintButton"
			type="button"
			class="button is-primary statistics-print-button"
			@click="$emit('print')"
		>
			<i class="fas fa-print"></i>
			<span>{{ $t('statistics.print') }}</span>
		</button>
	</div>
</template>

<script>
import StatisticsStructureSelect from './StatisticsStructureSelect.vue';

export default {
	name: 'StatisticsFilterPanel',

	components: {
		StatisticsStructureSelect
	},

	props: {
		buildingFilterId: {
			type: [String, Number],
			default: ''
		},
		buildingOptions: {
			type: Array,
			default: () => []
		},
		compareMode: {
			type: Boolean,
			default: false
		},
		isStructureExpanded: {
			type: Function,
			required: true
		},
		loading: {
			type: Boolean,
			default: false
		},
		loadingBuildings: {
			type: Boolean,
			default: false
		},
		loadingTree: {
			type: Boolean,
			default: false
		},
		selectedCustomer: {
			type: Object,
			default: null
		},
		showCompareButton: {
			type: Boolean,
			default: false
		},
		showPrintButton: {
			type: Boolean,
			default: false
		},
		start: {
			type: String,
			default: ''
		},
		stop: {
			type: String,
			default: ''
		},
		structureDropdownOpen: {
			type: Boolean,
			default: false
		},
		structureOptions: {
			type: Array,
			default: () => []
		},
		structureSearch: {
			type: String,
			default: ''
		}
	},

	methods: {
		focusStructureSearch() {
			this.$refs.structureSelect?.focusSearch();
		}
	}
};
</script>
